<template>
    <div
        :class="styleClass"
        @mouseleave="hideFlyout"
    >
        <slot />
    </div>
</template>
<script>

export default {
    name: 'NavFlyout',
    props: {
        styleClass: {
            type: String,
            default: null
        }
    },
    methods: {
        hideFlyout() {
            document.body.classList.remove('flyout-is-active')
        }
    }
}
</script>
<style lang="scss" scoped>
    .NavFlyout  {
        display: none;

        @include media-query(desk) {
            display: block;
            position: absolute;
            padding: getSpacing('medium') 0;
            top: -100vw;
            transition: all 1600ms cubic-bezier(0.23, 1, 0.32, 1);
            width: 100%;
            left: 0;
            z-index: 2;
            min-height: 465px;
            background-color: $border-color;

            body.flyout-is-active & {
                top: 100%;
                transition: all 600ms cubic-bezier(0.23, 1, 0.32, 1);
            }
        }

        h5 {
            font-size: 1rem;
        }

        .BaseButton {
            padding-left: 1rem;
            padding-right: 1rem;
            position: absolute;
            bottom: 2rem;
        }

        &--do-see { 
            padding: 0;
            min-height: 0;
        }
    }

    .NavFlyout__list {
        font-size: 0.8rem;
        margin-bottom: getSpacing('base');
    }

    .NavFlyout__border {
        border-right: 1px solid rgba($color: #C9C4BC, $alpha: 0.3)
    }

    .NavFlyout__icon {
        color: getColour('blue');
        height: 36px;
        width: 36px;
    }

    .NavFlyout__flex {
        display: flex;
    }

    .NavFlyout__spacing {
        padding: getSpacing(medium) 0;
    }
</style>
